(function() {
    var navList = document.querySelector(".gh-nav-list");
    var navBtnLeft = document.querySelector(".gh-nav-btn-left");
    var navBtnRight = document.querySelector(".gh-nav-btn-right");
    var hideClass = "gh-nav-btn-hidden";

    if (!navList || !navBtnLeft || !navBtnRight) {
        return;
    }

    var box = navList.getBoundingClientRect();

    // Scroll left
    navBtnLeft.addEventListener("click", function() {
        navList.scrollBy({
            left: -200,
            behavior: "smooth"
        });
    });

    // Scroll right
    navBtnRight.addEventListener("click", function() {
        navList.scrollBy({
            left: 200,
            behavior: "smooth"
        });
    });

    // Show/hide buttons after scroll
    function scrollHandler() {
        if (navList.scrollLeft <= 0) {
            navBtnLeft.classList.toggle(hideClass, true);
        } else {
            navBtnLeft.classList.toggle(hideClass, false);
        }

        if (Math.ceil(navList.scrollLeft + box.width) >= navList.scrollWidth) {
            navBtnRight.classList.toggle(hideClass, true);
        } else {
            navBtnRight.classList.toggle(hideClass, false);
        }
    }

    // Add scroll listener
    navList.addEventListener("scroll", scrollHandler);

    // Handle window resize
    window.addEventListener("resize", function() {
        box = navList.getBoundingClientRect();
        scrollHandler();
    });

    // First page render
    scrollHandler();
})();